import { render } from "./IssuesByUID.vue?vue&type=template&id=3cb70053&scoped=true"
import script from "./IssuesByUID.vue?vue&type=script&lang=js"
export * from "./IssuesByUID.vue?vue&type=script&lang=js"

import "./IssuesByUID.vue?vue&type=style&index=0&id=3cb70053&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cb70053"

export default script